module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "product-header"
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 6
    }
  }, [_c('span', [_vm._v("商品信息")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_c('span', [_vm._v("单价")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_c('span', [_vm._v("数量")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_c('span', [_vm._v("补差")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_c('span', [_vm._v("优惠方式")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_c('span', [_vm._v("优惠信息")])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_c('span', [_vm._v("小计")])])], 1), _vm._v(" "), _vm._l((_vm.details), function(detail, index) {
    return _c('div', [_c('el-row', {
      attrs: {
        "id": "cart-detail-entity"
      }
    }, [_c('el-col', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "text-align": "center"
      },
      attrs: {
        "span": 6
      }
    }, [_c('img', {
      staticClass: "cover",
      attrs: {
        "src": _vm._f("cdn-filter")(detail.product.cover)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "pro_name"
    }, [_vm._v(_vm._s(detail.product.name))])]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [(_vm.inReduceActivity(detail.product)) ? _c('span', {
      staticClass: "price-text"
    }, [_vm._v("\n          ￥"), _c('s', [_vm._v(_vm._s(detail.product.unitPrice))]), _vm._v("\n          " + _vm._s(detail.product.unitPrice - detail.product.discountPrice) + "\n        ")]) : _c('span', {
      staticClass: "price-text"
    }, [_vm._v("￥" + _vm._s(detail.product.unitPrice))])]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_c('span', [_vm._v("\n        " + _vm._s(detail.amount) + "\n      ")])]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_c('span', {
      staticClass: "price-text"
    }, [_vm._v("￥" + _vm._s(detail.premium ? detail.premium.toFixed(2) : 0))])]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticStyle: {
        "margin-top": "40px",
        "height": "0"
      },
      attrs: {
        "id": "promotion"
      }
    }, [_c('div', {
      staticStyle: {
        "border-radius": "5px",
        "height": "30px",
        "align-items": "center",
        "display": "flex",
        "justify-content": "center"
      },
      style: (_vm.coupons.length > 0 ? 'border: 1px solid transparent' : 'border: 1px solid transparent'),
      on: {
        "click": function($event) {
          _vm.toggleVisible(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../assets/quan.png"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.showIndex),
        expression: "index===showIndex"
      }],
      staticClass: "sanjiao"
    }, [_c('img', {
      attrs: {
        "src": require("../assets/sanjiao_che.png"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.showIndex),
        expression: "index===showIndex"
      }],
      staticClass: "promotion_list"
    }, [(_vm.coupons.length > 0) ? _c('p', [_vm._v("此产品有以下券可用：")]) : _c('p', [_vm._v("此产品无可用券")]), _vm._v(" "), _vm._l((_vm.coupons), function(code, index) {
      return _c('div', {
        staticClass: "promotion_de",
        class: [_vm.codeClass(code, detail)],
        on: {
          "click": function($event) {
            _vm.handleChange(detail, code, detail.couponCodeId)
          }
        }
      }, [_c('div', {
        staticClass: "pr_price"
      }, [_vm._v("\n                ￥" + _vm._s((code.coupon.type === 0 || code.coupon.type === 3 || code.coupon.type === 4) ? code.coupon.offPrice : code.coupon.giftPrice) + "\n              ")]), _vm._v(" "), _c('div', {
        staticClass: "pr_sum"
      }, [_c('div', [_c('h3', [_vm._v(_vm._s(code.desc))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dateFormat(code.startTime)) + "-" + _vm._s(_vm.dateFormat(code.endTime)))])])]), _vm._v(" "), _c('div', {
        staticClass: "check_"
      })])
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "background": "#0077db",
        "width": "100%",
        "height": "30px",
        "line-height": "30px",
        "color": "#fff",
        "font-size": "14px"
      },
      on: {
        "click": function($event) {
          _vm.showIndex = -1
        }
      }
    }, [_vm._v("确定\n            ")])], 2)])]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "text-align": "center",
        "height": "114px",
        "display": "flex",
        "align-items": "center",
        "justify-content": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_c('div', [_vm._v(_vm._s(_vm.discountInfo(detail)))])]), _vm._v(" "), _c('el-col', {
      staticStyle: {
        "height": "114px",
        "display": "flex",
        "align-items": "center",
        "justify-content": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "center",
        "flex-direction": "column"
      }
    }, [_c('div', {
      staticClass: "price-text"
    }, [_vm._v("￥" + _vm._s(detail.totalPrice ? detail.totalPrice.toFixed(2) : 0))]), _vm._v(" "), (_vm.SaleActivity.givingPeriodStrategy.matched(detail.product.serialId)) ? _c('div', {
      staticStyle: {
        "color": "#666"
      }
    }, [_vm._v("\n        (赠送服务费：" + _vm._s(_vm.SaleActivity.givingPeriodStrategy.calGivingMoney(detail.product.serialId)) + ")\n        ")]) : _vm._e()])])], 1)], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-354e697c!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderDetails.vue
// module id = 1029
// module chunks = 40